module.exports = __webpack_public_path__ + "static/media/public_agreement.3897ba64.pdf";